import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const CheckboxButton = props => {
  const { icon, caption, controlFunc } = props;

  let iconClass;

  switch (icon) {
    case 'tick':
      iconClass = 'checkbox-button__icon--tick';
      break;
    case 'cross':
      iconClass = 'checkbox-button__icon--cross';
      break;
    default:
      iconClass = '';
      break;
  }

  return (
    <button className="checkbox-button" onClick={controlFunc}>
      <span className={`checkbox-button__icon ${iconClass}`} />
      {caption}

    </button>
  );
};

CheckboxButton.propTypes = {
  icon: PropTypes.oneOf(['tick', 'cross']),
  caption: PropTypes.string.isRequired,
  controlFunc: PropTypes.func.isRequired,
};

export default CheckboxButton;
